import Artpunk from './img/artpunk.jpg';
import BrainTumor from './img/brain-tumour.JPG';
// import Pumpfun from './img/multi-pump.png';
// import Buntfun from './img/bunt.jpg';
import GengOne from './img/gengone.png';
import Membula from './img/membula.png';
import Casino from './img/casino.png';
import ClosedPump from './img/closed-pump.png';
import TaxPump from './img/tax-pump.png';
import EVMPump from './img/evm-pump.png';
import PresalePump from './img/wildgo-presale.png';
import MiningGame from './img/mining-game.png';
import Pdf from './img/pdf-ask-answer.jpg';
import RewardStaking from './img/reward-staking.png';
import Translation from './img/translation.jpg';
import Vkingplays from './img/vkingplays.jpg';
import WizardTech from './img/wizard-tech.png';
import Jackpot from './img/jackpot.png';
import Bitcoin from './img/bitcoin.JPG';
import Similarity from './img/similarity.JPG';
import Vehicle from './img/vehicle.gif';
import Bitmap from './img/bitmap.png';
import ArbitragyBot from './img/arbitragyBot.png';
import CopytradingBot from './img/copyTrading.png';
import VolumeBot from './img/volumeBot.png';
import RaydiumSniper from './img/raydium-sniper.png';

const header = {
  homepage: 'https://www.cutupdev.com/',
  title: 'Janus',
}

const about = {
  name: 'Janus Dev',
  role: 'Blockchain | Fullstack',
  description:
    '',
  resume: '',
  social: {
    gmail: "mailto:devcutup@gmail.com", 
    github: 'https://github.com/cutupdev',
    // linkedin: 'https://linkedin.com',
    whatsapp: 'https://wa.me/13137423660',
    telegram: 'https://t.me/DevCutup',
    twitter: 'https://twitter.com/devcutup',
    instagram: 'https://www.instagram.com/januscutup/',
    youtube: 'https://www.youtube.com/@Janus-dev',
  },
}

const projects = [
  {
    name: 'Pumpfun',
    image: GengOne,
    description:
      'Pump.fun fork that supports several functions on solana',
    stack: ['Solana', 'Rust', 'Anchor', 'liquidity', 'Node.js', 'Next.js', 'MongoDB'],
    code: 'https://github.com/cutupdev/Pumpfun-solana-smart-contract',
    online: 'https://geng.one/',
    preview: ''
  },
  {
    name: 'Mining game',
    image: MiningGame,
    description:
      'Mining game that run miners and get lamports',
    stack: ['Solana', 'Web3', 'Miner', 'Node.js', 'Next.js', 'MongoDB'],
    code: 'https://github.com/cutupdev/Solana-Bitcoin-Staking-Game-Frontend',
    online: 'https://www.mining.ghosty.cash/',
    preview: 'https://mining-game-cutupdev.vercel.app/'
  },
  {
    name: 'Tax-Pump',
    image: TaxPump,
    description:
      'Pump.fun fork that supports tax token and spl token as quote on Solana',
    stack: ['Solana', 'Rust', 'Anchor', 'token-2022', 'Node.js', 'Next.js', 'MongoDB'],
    code: 'https://github.com/cutupdev/Pumpfun-solana-smart-contract',
    online: 'https://mayosol.com/',
    preview: 'https://tax-pump-cutupdev.vercel.app/'
  },
  {
    name: 'EVM-Pump',
    image: EVMPump,
    description:
      'Pump.fun fork on EVM with additional functionalities',
    stack: ['EVM', 'Solidity', 'liquidity', 'Node.js', 'Next.js', 'MongoDB'],
    code: 'https://github.com/cutupdev/EVM-Pumpfun-Smart-Contract',
    online: 'https://ape.store/',
    preview: ''
  },
  {
    name: 'Casino-Tool',
    image: Casino,
    description:
      'Casino game tool that uses gamba react module',
    stack: ['Solana', 'Rust', 'Anchor', 'liquidity', 'Node.js', 'React.js', 'MongoDB'],
    code: 'https://github.com/cutupdev/Solana-Casino-Game-Tool-Private',
    online: '',
    preview: 'https://solana-casino-cutupdev.vercel.app/'
  },
  {
    name: 'Presale-Pump',
    image: PresalePump,
    description:
      'Pump.fun fork that uses presaled quote for initial liquidity on Solana',
    stack: ['Solana', 'Rust', 'Anchor', 'presale', 'Node.js', 'Next.js', 'MongoDB'],
    code: 'https://github.com/cutupdev/Pumpfun-solana-smart-contract',
    online: 'https://wildgo.xyz/',
    preview: 'https://wildgo-presale-cutupdev.vercel.app/'
  },
  {
    name: 'Closed-Pump',
    image: ClosedPump,
    description:
      'Pump.fun fork that restricts bot token mint and buy on Solana',
    stack: ['Solana', 'Rust', 'Anchor', 'liquidity', 'Node.js', 'Next.js', 'MongoDB'],
    code: 'https://github.com/cutupdev/Pumpfun-solana-smart-contract',
    online: 'https://www.closed.digital/',
    preview: 'https://closed-pump-cutupdev.vercel.app/'
  },
  {
    name: 'Casino Games',
    image: Vkingplays,
    description:
      'Several Casino Game Tool by payment using credit card',
    stack: ['Javascript', 'React.js', 'Node.js', 'MongoDB'],
    code: 'https://github.com/cutupdev/Vkingplays-Private',
    online: 'https://uat.vkingplays.com/',
    preview: ''
  },
  {
    name: 'Volume bot',
    image: VolumeBot,
    description:
      'Volume bot to increase token volume. Distribution of SOL to multiple wallets and execute automated buy and sell transactions on the Solana Raydium/Pumpfun',
    stack: ['Solana', 'Raydium', 'Pumpfun', 'Volume-bot', 'Typescript'],
    code: 'https://github.com/cutupdev/Solana-Raydium-Volume-Bot',
    online: 'https://github.com/cutupdev/Solana-Raydium-Volume-Bot',
    preview: ''
  },
  {
    name: 'Raydium sniper',
    image: RaydiumSniper,
    description:
      'Sniper bot for raydium and pumpfun, enabling to buy immediately when token launched on raydium, pumpfun or pumpswap',
    stack: ['Raydium', 'Pumpfun', 'PumpSwap', 'Sniper', 'Bot', 'Rust'],
    code: 'https://github.com/cutupdev/Solana-Raydium-Sniper-Bot',
    online: 'https://github.com/cutupdev/Solana-Raydium-Sniper-Bot',
    preview: ''
  },
  {
    name: 'Copy trading bot',
    image: CopytradingBot,
    description:
      'Copytrade target wallet activity based on analysis of profitability in few seconds',
    stack: ['Copytrading', 'Wallet tracking', 'Pumpfun', 'Raydium', 'Rust'],
    code: 'https://github.com/cutupdev/Solana-Copytrading-bot',
    online: 'https://github.com/cutupdev/Solana-Copytrading-bot',
    preview: ''
  },
  {
    name: 'Arbitragy bot',
    image: ArbitragyBot,
    description:
      'Solana arbitragy bot on several dex platforms such as raydium and meteora',
    stack: ['Arbitragy', 'Raydium', 'Meteora', 'Solana', 'Rust'],
    code: 'https://github.com/cutupdev/Solana-Arbitrage-Bot',
    online: 'https://github.com/cutupdev/Solana-Arbitrage-Bot',
    preview: ''
  },
  {
    name: 'Artpunk',
    image: Artpunk,
    description:
      'NFT staking / unstaking on Solana chain',
    stack: ['Smart Contract', 'Web3', 'Rust', 'Typescript'],
    code: 'https://github.com/cutupdev/Solana-Artpunk-Unstaking-Private',
    online: 'https://artpunks.fun/',
    preview: ''
  },
  {
    name: 'Jackpot Game',
    image: Jackpot,
    description:
      'Jackpot Game on Solana',
    stack: ['Solana', 'P2E Game', 'Next.js', 'MongoDB', 'Web3'],
    code: 'https://github.com/cutupdev/Jackpot-Solana-Frontend',
    online: 'https://app.mctoken.xyz/',
    preview: ''
  },
  {
    name: 'Rewards Staking',
    image: RewardStaking,
    description:
      'Rewards Staking for Kingdom of Dwarves NFT collections on Solana Chain',
    stack: ['Rust', 'TypeScript'],
    code: 'https://github.com/cutupdev/Solana-Kod-Reward-Staking-Private',
    online: 'https://anybodies.io/c/kod',
    preview: ''
  },
  {
    name: 'Bitmap community',
    image: Bitmap,
    description:
      'Ordinal inscription service',
    stack: ['Bitcoin', 'Ordinals', 'Inscription', 'Typescript'],
    code: 'https://github.com/cutupdev/Bitmap-Community-Private',
    online: 'https://bitmap.community/',
    preview: ''
  },
  {
    name: 'Bitcoin wallet toolkit',
    image: Membula,
    description:
      'This project offers various useful functionalities for bitcoin wallet',
    stack: ['Javascript', 'Bitcoin', 'Ordinals', 'Runes'],
    code: 'https://github.com/cutupdev/Btc-Wallet-Support-Toolkit-Private',
    online: 'https://www.membula.io/',
    preview: ''
  },
  {
    name: 'Wizard-Tech',
    image: WizardTech,
    description:
      'Offering customized emotional advice based on analysis of emotion based on words and face',
    stack: ['Python', 'Django', 'HuggingFace', 'BERT', 'CNN'],
    code: 'https://github.com/cutupdev/Wizard-Tech-Private',
    online: 'https://wizardtech.carrd.co/',
    preview: ''
  },
  {
    name: 'Bitcoin price prediction',
    image: Bitcoin,
    description:
      'Bitcoin price prediction project using LSTM',
    stack: ['Python', 'Keras', 'LSTM', 'Binance API'],
    code: 'https://github.com/cutupdev/Bitcoin-Price-Prediction-Model-Deep-Research-in-LSTM-GRU/',
    online: 'https://github.com/cutupdev/Bitcoin-Price-Prediction-Model-Deep-Research-in-LSTM-GRU/',
    preview: ''
  },
  {
    name: 'Vehicle counting project',
    image: Vehicle,
    description:
      'Real time vehicle counting',
    stack: ['Python', 'YOLO'],
    code: 'https://github.com/cutupdev/Vehicle-Real-Time-Counting-YOLO/',
    online: 'https://github.com/cutupdev/Vehicle-Real-Time-Counting-YOLO/',
    preview: ''
  },
  {
    name: 'PDF Question-Answer System',
    image: Pdf,
    description:
      'PDF upload, analyze. When clients ask about the content, search suitable content and offer result',
    stack: ['Python', 'OpenAI', 'Embedding'],
    code: 'https://github.com/cutupdev/pdf-ask-system',
    online: 'https://sharly.ai/',
    preview: ''
  },
  {
    name: 'Clothes similarity app',
    image: Similarity,
    description:
      'Clothes similarity app, clients can order styles what they want',
    stack: ['Python', 'tensorflow', 'encode', 'similarity-search'],
    code: 'https://github.com/cutupdev/Clothes-Similarity-Comparison/',
    online: 'https://ioannotator.com/image-similarity-search/',
    preview: ''
  },
  {
    name: 'English-Fula Translation',
    image: Translation,
    description:
      'English-Fula Translation System using Marian',
    stack: ['Python', 'LLM', 'Marian NMT'],
    code: 'https://github.com/cutupdev/fula-to-english-translation/',
    online: 'https://www.stars21.com/translator/english/fula/',
    preview: ''
  },
  {
    name: 'Brain Tumor',
    image: BrainTumor,
    description:
      'Brain Tumor segmentaion, trained by BraTS2020 datasets',
    stack: ['Tensorflow', 'Encoder', 'Decoder'],
    code: 'https://github.com/cutupdev/Brain-Tumors-Segmentation-using-Encoder-Decoder/',
    online: 'https://github.com/cutupdev/Brain-Tumors-Segmentation-using-Encoder-Decoder/',
    preview: ''
  },
]

const skills = [
  'Smart Contact',
  'Web3',
  'Rust',
  'Anchor',
  'Go',
  'Solidity',
  'JavaScript',
  'TypeScript',
  'Node.js',
  'Django',
  'MongoDB',
  'PostgreSQL',
  'ChromaDB',
  'AI',
  'LLM',
  'React',
  'Next.js',
  'TailwindCSS',
  'Git',
  'Docker',
  'AWS',
]

const contact = {
  email: 'devcutup@gmail.com',
}

export { header, about, projects, skills, contact }
